export default __webpack_public_path__ + "locales/cs/Settings.json?hash=850fa2227205492f4dc91d80cbf7f8fc";